import React, { FC } from 'react'

const UploadsPage: FC = () => (
    <>
        <div className='row gy-0'>
            <h1 className='dashboard-hello'>
                Uploads
            </h1>
        </div>
    </>
)

const UploadsPageWrapper: FC = () => {

    return (
        <>
            <UploadsPage />
        </>
    )
}

export { UploadsPageWrapper }
